import React, { useState } from 'react';
import { ui } from './ui';
import { TYPE_META, parsePastedText } from './paperUtils';

// Mode B: smart paste parser. onAdd(questions) appends them as a new section.
export default function PastePanel({ onAdd }) {
  const [raw, setRaw] = useState('');
  const [parsed, setParsed] = useState(null);
  return (
    <div style={ui.card}>
      <b>📋 Mode B — Smart Paste</b>
      <div style={{ fontSize: 12, color: '#64748b' }}>Paste text from Word / PDF / WhatsApp. Detects “1.”, “Q2)”, options (A)–(D), “[2 Marks]”, “Ans:” and “OR”.</div>
      <textarea style={{ ...ui.input, minHeight: 130, marginTop: 6 }} value={raw} onChange={(e) => { setRaw(e.target.value); setParsed(null); }}
        placeholder={'1. The SI unit of force is (A) Joule (B) Newton (C) Watt (D) Pascal [1 Mark]\nAns: Newton\n2. Define inertia. [2 Marks]'} />
      <div style={ui.row}>
        <button type="button" style={ui.btn} onClick={() => setParsed(parsePastedText(raw))} disabled={!raw.trim()}>Parse</button>
        {parsed && parsed.length > 0 && (
          <button type="button" style={ui.btnGreen} onClick={() => { onAdd(parsed); setRaw(''); setParsed(null); }}>
            Add {parsed.length} question(s) as a section
          </button>
        )}
      </div>
      {parsed && !parsed.length && <div style={ui.err}>No numbered questions found. Start each question with “1.” or “Q1)”.</div>}
      {parsed && parsed.length > 0 && (
        <div style={{ marginTop: 8, maxHeight: 220, overflow: 'auto', fontSize: 12 }}>
          {parsed.map((q, i) => (
            <div key={q.id} style={{ borderBottom: '1px solid #e2e8f0', padding: '4px 0' }}>
              <b>{i + 1}. [{TYPE_META[q.type]} · {q.marks}m]</b> {q.text.slice(0, 90)}{q.options.length ? ` — ${q.options.length} options` : ''}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
